import React, { useState, useEffect } from "react";
import { Typography, Button, Box } from "@mui/material";
import { DataGridPro } from '@mui/x-data-grid-pro';
import ReportToolbar from "../ReportToolbar";
import ReportFooter from "../ReportFooter";
import axios from "axios";
import { APIURL } from "../../../config";

export default function ClaimCollectionReport(props) {
    const columns = [
        {
            field: "claim_ID",
            headerName: "Claim ID",
            width: 100,
        },
        {
            field: "PatientName",
            headerName: "Patient Name",
            width: 150,
        },
        {
            field: "Ins_Carrier",
            headerName: "Ins Carrier",
            width: 125,
        },
        {
            field: "Trans_Date",
            headerName: "Trans Date",
            width: 100,
        },
        {
            field: "Net_Sale",
            headerName: "Net Sale",
            width: 100,
        },
        {
            field: "Ins_Recieve",
            headerName: "Ins Receivable",
            width: 100,
        },
        {
            field: "Ins_Payment",
            headerName: "Ins Payment",
            width: 100,
        },
        {
            field: "Pat_Payment",
            headerName: "Pat Payment",
            width: 100,
        },
        {
            field: "Collect_Amount",
            headerName: "Collection Amt",
            width: 100,
        },
        {
            field: "Collect_Reason",
            headerName: "Collection Reason",
            width: 125,
        },
        {
            field: "ClaimStatus",
            headerName: "Status",
            width: 100,
        },
    ];

    const rows = props.data.collection.map((claim, index) => {
        const claimDets = {
            id: index,
            claim_ID: claim.Claim_ID,
            PatientName: claim.Patient_Name,
            Ins_Carrier: claim.Ins_Carrier,
            Net_Sale: claim.Net_Sale,
            Ins_Recieve: claim.Ins_Recieve,
            Ins_Payment: claim.Ins_Payment,
            Pat_Payment: claim.Pat_Payment,
            Collect_Amount: claim.Collect_Amount,
            Collect_Reason: claim.Collect_Reason,
            ClaimStatus: claim.status,
            Trans_Date: claim.Trans_Date,
        };
        return claimDets;
    });

    const totalRow = {
        id: 'total-row',
        claim_ID: '',
        PatientName: '',
        Ins_Carrier: '',
        Trans_Date: 'TOTAL:',
        Net_Sale: props.data.netTotal,
        Ins_Recieve: props.data.insRecTotal,
        Ins_Payment: props.data.insPayTotal,
        Pat_Payment: props.data.patPayTotal,
        Collect_Amount: props.data.collTotal,
        Collect_Reason: '',
        ClaimStatus: '',
        isTotal: true,
    };

    const CustomToolbar = () => {
        return (
            <ReportToolbar companyName={props.user.company_name} reportTitle="Claim Collection Report">
                <Box sx={{ pl: 1, pr: 1 }}>
                    <div style={{ fontSize: '16px', fontWeight: 'bold' }}>Carrier: Medicaid </div>
                    <div style={{ fontSize: '16px', fontWeight: 'bold' }}>Date Range: {props.data.from} - {props.data.to}</div>
                </Box>
            </ReportToolbar>
        );
    };

    return (
        <div style={{ width: '100%' }}>
            <div style={{ height: '80vh' }}>
                <DataGridPro
                    initialState={{ sorting: { sortModel: [{ field: "Trans_Date", sort: "desc" }] } }}
                    getRowId={(row) => row.id}
                    rows={rows}
                    columns={columns}
                    slots={{
                        toolbar: CustomToolbar,
                        footer: ReportFooter
                    }}
                    pinnedRows={{ bottom: [totalRow] }}
                    getRowClassName={(params) => {
                        return params.row.isTotal ? 'total-row' : '';
                    }}
                    sx={{
                        '& .total-row': {
                            backgroundColor: '#f5f5f5',
                            fontWeight: 'bold',
                            borderTop: '2px solid #ddd',
                            '&:hover': {
                                backgroundColor: '#f0f0f0',
                            }
                        }
                    }}
                    checkboxSelection={false}
                    disableRowSelectionOnClick
                    disableVirtualization
                    showToolbar
                />
            </div>
        </div>
    );
}